import _toConsumableArray from "/vercel/path0/reference-stores/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/vercel/path0/reference-stores/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/reference-stores/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/reference-stores/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/reference-stores/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["nacelleEntryId"],
    _excluded2 = ["lines"];
import _regeneratorRuntime from "/vercel/path0/reference-stores/gatsby/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";

var A = function A() {
  return "\n  fragment CartBuyerIdentity_buyerIdentity on CartBuyerIdentity {\n    countryCode\n    customer {\n      id\n      email\n      firstName\n      lastName\n      displayName\n    }\n    email\n    phone\n  }\n";
},
    _ = function _() {
  return "\n  fragment CartDiscountAllocation_discountAllocation on CartDiscountAllocation {\n    discountedAmount {\n      amount\n      currencyCode\n    }\n    ... on CartAutomaticDiscountAllocation {\n      title\n      discountedAmount {\n        amount\n        currencyCode\n      }\n    }\n    ... on CartCodeDiscountAllocation {\n      code\n      discountedAmount {\n        amount\n        currencyCode\n      }\n    }\n    ... on CartCustomDiscountAllocation {\n      title\n      discountedAmount {\n        amount\n        currencyCode\n      }\n    }\n  }\n";
},
    S = function S() {
  return "\n  fragment Cart_extendCart on Cart {\n    id\n  }\n";
},
    T = function T() {
  return "\n  fragment CartLine_extendCartLine on CartLine {\n    id\n  }\n";
},
    U = function U() {
  return "\n  fragment Merchandise_merchandise on ProductVariant {\n    availableForSale\n    compareAtPrice {\n      ...Money_money\n    }\n    price {\n      ...Money_money\n    }\n    requiresShipping\n    title\n    image {\n      id\n      url\n      altText\n      width\n      height\n    }\n    product {\n      handle\n      onlineStoreUrl\n      tags\n      title\n      vendor\n    }\n    selectedOptions {\n      name\n      value\n    }\n  }\n";
},
    g = function g() {
  return "\n  fragment Money_money on MoneyV2 {\n    currencyCode\n    amount\n  }\n";
},
    L = function L(r) {
  var t, e, o, s, n, y;
  return "\n  fragment Cart_cart on Cart {\n    ...Cart_extendCart\n    id\n    checkoutUrl\n    createdAt\n    discountAllocations {\n      ...CartDiscountAllocation_discountAllocation\n    }\n    updatedAt\n    buyerIdentity {\n      ...CartBuyerIdentity_buyerIdentity\n    }\n    lines(first: $numCartLines, after: $afterCursor) {\n      pageInfo {\n        hasNextPage\n        hasPreviousPage\n        endCursor\n      }\n      nodes {\n        ...CartLine_extendCartLine\n        id\n        quantity\n        attributes {\n          key\n          value\n        }\n        cost {\n          subtotalAmount {\n            ...Money_money\n          }\n          totalAmount {\n            ...Money_money\n          }\n          amountPerQuantity {\n            ...Money_money\n          }\n          compareAtAmountPerQuantity {\n            ...Money_money\n          }\n        }\n        discountAllocations {\n          ...CartDiscountAllocation_discountAllocation\n        }\n        merchandise {\n          ... on ProductVariant {\n            sourceEntryId: id\n          }\n          ...Merchandise_merchandise\n        }\n      }\n    }\n    cost {\n      checkoutChargeAmount {\n        ...Money_money\n      }\n      subtotalAmount {\n        ...Money_money\n      }\n      subtotalAmountEstimated\n      totalAmount {\n        ...Money_money\n      }\n      totalAmountEstimated\n      totalDutyAmount {\n        ...Money_money\n      }\n      totalDutyAmountEstimated\n      totalTaxAmount {\n        ...Money_money\n      }\n      totalTaxAmountEstimated\n    }\n    note\n    attributes {\n      key\n      value\n    }\n    discountCodes {\n      code\n    }\n  }\n  ".concat((t = r == null ? void 0 : r.MERCHANDISE) != null ? t : U(), "\n  ").concat((e = r == null ? void 0 : r.BUYER_IDENTITY) != null ? e : A(), "\n  ").concat((o = r == null ? void 0 : r.DISCOUNT_ALLOCATION) != null ? o : _(), "\n  ").concat((s = r == null ? void 0 : r.EXTEND_CART) != null ? s : S(), "\n  ").concat((n = r == null ? void 0 : r.EXTEND_CART_LINE) != null ? n : T(), "\n  ").concat((y = r == null ? void 0 : r.MONEY) != null ? y : g(), "\n");
},
    N = function N() {
  return "\n  fragment CartUserError_userErrors on CartUserError {\n    code\n    field\n    message\n  }\n";
},
    O = /* @__PURE__ */new Set(["BUYER_IDENTITY", "DISCOUNT_ALLOCATION", "EXTEND_CART", "EXTEND_CART_LINE", "MERCHANDISE", "MONEY", "USER_ERRORS"]),
    m = {
  BUYER_IDENTITY: A,
  CART: L,
  DISCOUNT_ALLOCATION: _,
  EXTEND_CART: S,
  EXTEND_CART_LINE: T,
  MERCHANDISE: U,
  MONEY: g,
  USER_ERRORS: N
},
    p = m,
    b = function b() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return "\n  query Cart(\n    $id: ID!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cart(id: $id) {\n      ...Cart_cart\n    }\n  }\n  ".concat(p.CART(r), "\n");
},
    w = {
  CART: b
};

function v(_ref) {
  var r = _ref.lines,
      t = _ref.shopifyShopId,
      e = _ref.locale;
  return r == null ? void 0 : r.map(function (o) {
    var s = o.merchandise.sourceEntryId.split("gid://shopify/ProductVariant/")[1].replace("/", "");
    var n = "id://SHOPIFY/".concat(t, "/default/PRODUCT_VARIANT/").concat(s, "/").concat(e);
    return typeof window != "undefined" ? n = globalThis.btoa(n) : n = Buffer.from(n).toString("base64"), _objectSpread(_objectSpread({}, o), {}, {
      merchandise: _objectSpread(_objectSpread({}, o.merchandise), {}, {
        nacelleEntryId: n
      })
    });
  });
}

function P(_ref2) {
  var r = _ref2.cart,
      t = _ref2.shopifyShopId,
      e = _ref2.locale;
  var o;
  return _objectSpread(_objectSpread({}, r), {}, {
    lines: v({
      lines: r.lines.nodes,
      shopifyShopId: t,
      locale: e
    }),
    note: (o = r.note) != null ? o : void 0
  });
}

function D(r) {
  var e, o;
  return ((o = (e = r.split(".myshopify").shift()) == null ? void 0 : e.split("//").pop()) == null ? void 0 : o.split(".").pop()) || r;
}

var x = "[@nacelle/shopify-checkout] in order to create a checkout server-side, you must provide a fetch API-compatible `fetchClient` capable of running on both the client & server. Examples include `isomorphic-unfetch` and `cross-fetch`.",
    M = "[@nacelle/shopify-cart]: missing required parameters. You must provide a `shopifyShopId` or a `shopifyCustomEndpoint`.",
    Z = "[@nacelle/shopify-cart]: missing required parameter `shopifyStorefrontAccessToken`.";

function B(_ref3) {
  var r = _ref3.shopifyShopId,
      t = _ref3.shopifyStorefrontAccessToken,
      e = _ref3.shopifyCustomEndpoint,
      o = _ref3.fetchClient;
  var s = e || "";
  if (!t) throw new Error(Z);

  if (!s) {
    if (!r) throw new Error(M);
    s = "https://".concat(D(r), ".myshopify.com/api/2023-01/graphql");
  }

  return function (_ref4) {
    var y = _ref4.query,
        C = _ref4.variables;
    var u = o;
    if (!u) if (typeof window != "undefined") u = window.fetch;else throw new Error(x);
    return u(s, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": t
      },
      body: JSON.stringify({
        query: y,
        variables: C
      })
    }).then(function (d) {
      return d.json();
    });
  };
}

function R(_x) {
  return _R.apply(this, arguments);
}

function _R() {
  _R = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            r = _ref5.cart, t = _ref5.customFragments, e = _ref5.gqlClient, o = _ref5.language, s = _ref5.country;
            _context.prev = 1;

            if (!r) {
              _context.next = 12;
              break;
            }

            i = _objectSpread({}, r.lines.pageInfo), a = r.lines.nodes;

          case 4:
            if (!(i.hasNextPage && i.endCursor)) {
              _context.next = 11;
              break;
            }

            _context.next = 7;
            return e({
              query: w.CART(t),
              variables: {
                id: r.id,
                afterCursor: i.endCursor,
                language: o,
                country: s
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 7:
            c = _context.sent;
            i.hasNextPage = ((y = (n = c.data) == null ? void 0 : n.cart) == null ? void 0 : y.lines.pageInfo.hasNextPage) || !1, i.endCursor = (u = (C = c.data) == null ? void 0 : C.cart) == null ? void 0 : u.lines.pageInfo.endCursor, (E = (d = c.data) == null ? void 0 : d.cart) != null && E.lines.nodes && a.push.apply(a, _toConsumableArray(c.data.cart.lines.nodes));

          case 9:
            _context.next = 4;
            break;

          case 11:
            return _context.abrupt("return", _objectSpread(_objectSpread({}, r), {}, {
              lines: {
                pageInfo: i,
                nodes: a
              }
            }));

          case 12:
            return _context.abrupt("return", null);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](1);
            throw new Error(String(_context.t0));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 15]]);
  }));
  return _R.apply(this, arguments);
}

function f(_ref6) {
  var r = _ref6.cart,
      t = _ref6.userErrors,
      e = _ref6.errors,
      o = _ref6.shopifyShopId,
      s = _ref6.locale;
  var n = {
    cart: null,
    userErrors: null,
    errors: null
  };
  return e != null && e.length && (n.errors = e), t != null && t.length && (n.userErrors = t), r && (n.cart = P({
    cart: r,
    shopifyShopId: o,
    locale: s
  })), n;
}

function Y(r) {
  try {
    var t = r;
    typeof window != "undefined" ? t = globalThis.atob(r) : t = Buffer.from(r, "base64").toString("utf-8");
    var e = q(t);
    return "gid://shopify/".concat(V(e.dataType), "/").concat(e.sourceEntryId);
  } catch (t) {
    throw new Error("Invalid Nacelle Entry Id for Cart - must be a Product Variant Nacelle Entry Id");
  }
}

function q(r) {
  var _r$split = r.split("id://"),
      _r$split2 = _slicedToArray(_r$split, 2),
      t = _r$split2[1],
      e = t.split("/");

  return {
    sourceName: e[0],
    externalId: e[1],
    sourceSubset: e[2],
    dataType: e[3],
    sourceEntryId: e[4],
    locale: e[5]
  };
}

function V(r) {
  if (r === "PRODUCT_VARIANT") return "ProductVariant";
  throw new Error("Only Product Variant Ids allowed");
}

function z(r, t) {
  var e = /(fragment )(\w+)( on )(\w+)/,
      o = e.exec(p[t]()),
      s = o[2],
      n = o[4],
      C = e.exec(r)[4];
  if (C !== n) throw new Error("".concat(t, " fragment expected to be on GraphQL type '").concat(n, "', but received '").concat(C, "'."));
  return r.replace(e, "$1".concat(s, "$3$4"));
}

var k = function k(r) {
  return O.has(r);
};

function X(r) {
  if (!r) return;
  var t = {};
  if (typeof r != "object" || Array.isArray(r)) throw new Error("`customFragments` must be an object. Please refer to `@nacelle/shopify-cart`'s README.");

  for (var _i = 0, _Object$entries = Object.entries(r); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        e = _Object$entries$_i[0],
        o = _Object$entries$_i[1];

    if (k(e)) t[e] = z(o, e);else throw new Error("Invalid custom fragment '".concat(e, "' provided."));
  }

  return t;
}

function $(r) {
  return r == null ? void 0 : r.map(function (t) {
    var e = t.nacelleEntryId,
        o = _objectWithoutProperties(t, _excluded),
        s = _objectSpread({}, o);

    return e && (s.merchandiseId = Y(e)), s;
  });
}

function j(_x2) {
  return _j.apply(this, arguments);
}

function _j() {
  _j = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref7) {
    var r, t, e, o, s, n, y, C, u, d;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            r = _ref7.cartId, t = _ref7.customFragments, e = _ref7.gqlClient, o = _ref7.shopifyShopId, s = _ref7.language, n = _ref7.country, y = _ref7.locale;
            _context2.prev = 1;
            _context2.next = 4;
            return e({
              query: w.CART(t),
              variables: {
                id: r,
                language: s,
                country: n
              }
            }).catch(function (E) {
              throw new Error(E);
            });

          case 4:
            u = _context2.sent;
            _context2.next = 7;
            return R({
              cart: (C = u.data) == null ? void 0 : C.cart,
              customFragments: t,
              gqlClient: e,
              language: s,
              country: n
            });

          case 7:
            d = _context2.sent;
            return _context2.abrupt("return", f({
              cart: d,
              userErrors: null,
              errors: u.errors,
              shopifyShopId: o,
              locale: y
            }));

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](1);
            throw new Error(String(_context2.t0));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 11]]);
  }));
  return _j.apply(this, arguments);
}

var H = function H() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartAttributesUpdate(\n    $cartId: ID!\n    $attributes: [AttributeInput!]!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    G = function G() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartBuyerIdentityUpdate(\n    $cartId: ID!\n    $buyerIdentity: CartBuyerIdentityInput!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    K = function K() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartCreate(\n    $input: CartInput!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartCreate(input: $input) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    Q = function Q() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartDiscountCodesUpdate(\n    $cartId: ID!\n    $discountCodes: [String!]\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    J = function J() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartLineAdd(\n    $cartId: ID!\n    $lines: [CartLineInput!]!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartLinesAdd(cartId: $cartId, lines: $lines) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    W = function W() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartLineRemove(\n    $cartId: ID!\n    $lineIds: [ID!]!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    F = function F() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartLineUpdate(\n    $cartId: ID!\n    $lines: [CartLineUpdateInput!]!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartLinesUpdate(cartId: $cartId, lines: $lines) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    rr = function rr() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation CartNoteUpdate(\n    $cartId: ID!\n    $note: String\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartNoteUpdate(cartId: $cartId, note: $note) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    tr = function tr() {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t;
  return "\n  mutation cartSelectedDeliveryOptionsUpdate(\n    $cartId: ID!\n    $selectedDeliveryOptions: [CartSelectedDeliveryOptionInput!]!\n    $numCartLines: Int = 250\n    $afterCursor: String\n    $country: CountryCode = ZZ\n    $language: LanguageCode = EN\n  ) @inContext(country: $country, language: $language) {\n    cartSelectedDeliveryOptionsUpdate(\n      cartId: $cartId\n      selectedDeliveryOptions: $selectedDeliveryOptions\n    ) {\n      cart {\n        ...Cart_cart\n      }\n      userErrors {\n        ...CartUserError_userErrors\n      }\n    }\n  }\n  ".concat(p.CART(r), "\n  ").concat((t = r.USER_ERRORS) != null ? t : p.USER_ERRORS(), "\n");
},
    I = {
  CART_ATTRIBUTES_UPDATE: H,
  CART_BUYER_IDENTITY_UPDATE: G,
  CART_CREATE: K,
  CART_DISCOUNT_CODES_UPDATE: Q,
  CART_LINE_ADD: J,
  CART_LINE_REMOVE: W,
  CART_LINE_UPDATE: F,
  CART_NOTE_UPDATE: rr,
  CART_SELECTED_DELIVERY_OPTIONS_UPDATE: tr
};

function er(_x3) {
  return _er.apply(this, arguments);
}

function _er() {
  _er = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref8) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            r = _ref8.attributes, t = _ref8.cartId, e = _ref8.customFragments, o = _ref8.gqlClient, s = _ref8.shopifyShopId, n = _ref8.language, y = _ref8.country, C = _ref8.locale;
            _context3.prev = 1;
            _context3.next = 4;
            return o({
              query: I.CART_ATTRIBUTES_UPDATE(e),
              variables: {
                cartId: t,
                attributes: r,
                language: n,
                country: y
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 4:
            a = _context3.sent;
            _context3.next = 7;
            return R({
              cart: (d = (u = a.data) == null ? void 0 : u.cartAttributesUpdate) == null ? void 0 : d.cart,
              customFragments: e,
              gqlClient: o,
              language: n,
              country: y
            });

          case 7:
            c = _context3.sent;
            return _context3.abrupt("return", f({
              cart: c,
              userErrors: (i = (E = a.data) == null ? void 0 : E.cartAttributesUpdate) == null ? void 0 : i.userErrors,
              errors: a.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](1);
            throw new Error(String(_context3.t0));

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[1, 11]]);
  }));
  return _er.apply(this, arguments);
}

function ar(_x4) {
  return _ar.apply(this, arguments);
}

function _ar() {
  _ar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref9) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            r = _ref9.buyerIdentity, t = _ref9.cartId, e = _ref9.customFragments, o = _ref9.gqlClient, s = _ref9.shopifyShopId, n = _ref9.language, y = _ref9.country, C = _ref9.locale;
            _context4.prev = 1;
            _context4.next = 4;
            return o({
              query: I.CART_BUYER_IDENTITY_UPDATE(e),
              variables: {
                cartId: t,
                buyerIdentity: r,
                language: n,
                country: y
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 4:
            a = _context4.sent;
            _context4.next = 7;
            return R({
              cart: (d = (u = a.data) == null ? void 0 : u.cartBuyerIdentityUpdate) == null ? void 0 : d.cart,
              customFragments: e,
              gqlClient: o,
              language: n,
              country: y
            });

          case 7:
            c = _context4.sent;
            return _context4.abrupt("return", f({
              cart: c,
              userErrors: (i = (E = a.data) == null ? void 0 : E.cartBuyerIdentityUpdate) == null ? void 0 : i.userErrors,
              errors: a.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](1);
            throw new Error(String(_context4.t0));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[1, 11]]);
  }));
  return _ar.apply(this, arguments);
}

function nr(_x5) {
  return _nr.apply(this, arguments);
}

function _nr() {
  _nr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref10) {
    var r, t, e, o, s, n, y, u, d, E, i, C, l, h, a, c;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            r = _ref10.customFragments, t = _ref10.gqlClient, e = _ref10.params, o = _ref10.shopifyShopId, s = _ref10.language, n = _ref10.country, y = _ref10.locale;
            C = {};
            _context5.prev = 2;

            if (e) {
              l = e.lines, h = _objectWithoutProperties(e, _excluded2);
              C = h, l && (C.lines = $(l));
            }

            _context5.next = 6;
            return t({
              query: I.CART_CREATE(r),
              variables: {
                input: C,
                language: s,
                country: n
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 6:
            a = _context5.sent;
            _context5.next = 9;
            return R({
              cart: (d = (u = a.data) == null ? void 0 : u.cartCreate) == null ? void 0 : d.cart,
              customFragments: r,
              gqlClient: t,
              language: s,
              country: n
            });

          case 9:
            c = _context5.sent;
            return _context5.abrupt("return", f({
              cart: c,
              userErrors: (i = (E = a.data) == null ? void 0 : E.cartCreate) == null ? void 0 : i.userErrors,
              errors: a.errors,
              shopifyShopId: o,
              locale: y
            }));

          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](2);
            throw new Error(String(_context5.t0));

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 13]]);
  }));
  return _nr.apply(this, arguments);
}

function or(_x6) {
  return _or.apply(this, arguments);
}

function _or() {
  _or = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            r = _ref11.cartId, t = _ref11.customFragments, e = _ref11.discountCodes, o = _ref11.gqlClient, s = _ref11.shopifyShopId, n = _ref11.language, y = _ref11.country, C = _ref11.locale;
            _context6.prev = 1;
            _context6.next = 4;
            return o({
              query: I.CART_DISCOUNT_CODES_UPDATE(t),
              variables: {
                cartId: r,
                discountCodes: e,
                language: n,
                country: y
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 4:
            a = _context6.sent;
            _context6.next = 7;
            return R({
              cart: (d = (u = a.data) == null ? void 0 : u.cartDiscountCodesUpdate) == null ? void 0 : d.cart,
              customFragments: t,
              gqlClient: o,
              language: n,
              country: y
            });

          case 7:
            c = _context6.sent;
            return _context6.abrupt("return", f({
              cart: c,
              userErrors: (i = (E = a.data) == null ? void 0 : E.cartDiscountCodesUpdate) == null ? void 0 : i.userErrors,
              errors: a.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](1);
            throw new Error(String(_context6.t0));

          case 14:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 11]]);
  }));
  return _or.apply(this, arguments);
}

function ir(_x7) {
  return _ir.apply(this, arguments);
}

function _ir() {
  _ir = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref12) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c, l;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            r = _ref12.cartId, t = _ref12.customFragments, e = _ref12.gqlClient, o = _ref12.lines, s = _ref12.shopifyShopId, n = _ref12.language, y = _ref12.country, C = _ref12.locale;
            _context7.prev = 1;
            a = $(o);
            _context7.next = 5;
            return e({
              query: I.CART_LINE_ADD(t),
              variables: {
                cartId: r,
                lines: a,
                language: n,
                country: y
              }
            }).catch(function (h) {
              throw new Error(h);
            });

          case 5:
            c = _context7.sent;
            _context7.next = 8;
            return R({
              cart: (d = (u = c.data) == null ? void 0 : u.cartLinesAdd) == null ? void 0 : d.cart,
              customFragments: t,
              gqlClient: e,
              language: n,
              country: y
            });

          case 8:
            l = _context7.sent;
            return _context7.abrupt("return", f({
              cart: l,
              userErrors: (i = (E = c.data) == null ? void 0 : E.cartLinesAdd) == null ? void 0 : i.userErrors,
              errors: c.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](1);
            throw new Error(String(_context7.t0));

          case 15:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 12]]);
  }));
  return _ir.apply(this, arguments);
}

function cr(_x8) {
  return _cr.apply(this, arguments);
}

function _cr() {
  _cr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref13) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            r = _ref13.cartId, t = _ref13.customFragments, e = _ref13.gqlClient, o = _ref13.lineIds, s = _ref13.shopifyShopId, n = _ref13.language, y = _ref13.country, C = _ref13.locale;
            _context8.prev = 1;
            _context8.next = 4;
            return e({
              query: I.CART_LINE_REMOVE(t),
              variables: {
                cartId: r,
                lineIds: o,
                language: n,
                country: y
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 4:
            a = _context8.sent;
            _context8.next = 7;
            return R({
              cart: (d = (u = a.data) == null ? void 0 : u.cartLinesRemove) == null ? void 0 : d.cart,
              customFragments: t,
              gqlClient: e,
              language: n,
              country: y
            });

          case 7:
            c = _context8.sent;
            return _context8.abrupt("return", f({
              cart: c,
              userErrors: (i = (E = a.data) == null ? void 0 : E.cartLinesRemove) == null ? void 0 : i.userErrors,
              errors: a.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 11:
            _context8.prev = 11;
            _context8.t0 = _context8["catch"](1);
            throw new Error(String(_context8.t0));

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 11]]);
  }));
  return _cr.apply(this, arguments);
}

function sr(_x9) {
  return _sr.apply(this, arguments);
}

function _sr() {
  _sr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref14) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c, l;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            r = _ref14.cartId, t = _ref14.customFragments, e = _ref14.gqlClient, o = _ref14.lines, s = _ref14.shopifyShopId, n = _ref14.language, y = _ref14.country, C = _ref14.locale;
            _context9.prev = 1;
            a = $(o);
            _context9.next = 5;
            return e({
              query: I.CART_LINE_UPDATE(t),
              variables: {
                cartId: r,
                lines: a,
                language: n,
                country: y
              }
            }).catch(function (h) {
              throw new Error(h);
            });

          case 5:
            c = _context9.sent;
            _context9.next = 8;
            return R({
              cart: (d = (u = c.data) == null ? void 0 : u.cartLinesUpdate) == null ? void 0 : d.cart,
              customFragments: t,
              gqlClient: e,
              language: n,
              country: y
            });

          case 8:
            l = _context9.sent;
            return _context9.abrupt("return", f({
              cart: l,
              userErrors: (i = (E = c.data) == null ? void 0 : E.cartLinesUpdate) == null ? void 0 : i.userErrors,
              errors: c.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 12:
            _context9.prev = 12;
            _context9.t0 = _context9["catch"](1);
            throw new Error(String(_context9.t0));

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[1, 12]]);
  }));
  return _sr.apply(this, arguments);
}

function dr(_x10) {
  return _dr.apply(this, arguments);
}

function _dr() {
  _dr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref15) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            r = _ref15.cartId, t = _ref15.customFragments, e = _ref15.gqlClient, o = _ref15.note, s = _ref15.shopifyShopId, n = _ref15.language, y = _ref15.country, C = _ref15.locale;
            _context10.prev = 1;
            _context10.next = 4;
            return e({
              query: I.CART_NOTE_UPDATE(t),
              variables: {
                cartId: r,
                note: o,
                language: n,
                country: y
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 4:
            a = _context10.sent;
            _context10.next = 7;
            return R({
              cart: (d = (u = a.data) == null ? void 0 : u.cartNoteUpdate) == null ? void 0 : d.cart,
              customFragments: t,
              gqlClient: e,
              language: n,
              country: y
            });

          case 7:
            c = _context10.sent;
            return _context10.abrupt("return", f({
              cart: c,
              userErrors: (i = (E = a.data) == null ? void 0 : E.cartNoteUpdate) == null ? void 0 : i.userErrors,
              errors: a.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](1);
            throw new Error(String(_context10.t0));

          case 14:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 11]]);
  }));
  return _dr.apply(this, arguments);
}

function ur(_x11) {
  return _ur.apply(this, arguments);
}

function _ur() {
  _ur = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref16) {
    var r, t, e, o, s, n, y, C, u, d, E, i, a, c;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            r = _ref16.cartId, t = _ref16.customFragments, e = _ref16.gqlClient, o = _ref16.selectedDeliveryOptions, s = _ref16.shopifyShopId, n = _ref16.language, y = _ref16.country, C = _ref16.locale;
            _context11.prev = 1;
            _context11.next = 4;
            return e({
              query: I.CART_SELECTED_DELIVERY_OPTIONS_UPDATE(t),
              variables: {
                cartId: r,
                selectedDeliveryOptions: o,
                language: n,
                country: y
              }
            }).catch(function (l) {
              throw new Error(l);
            });

          case 4:
            a = _context11.sent;
            _context11.next = 7;
            return R({
              cart: (d = (u = a.data) == null ? void 0 : u.cartSelectedDeliveryOptionsUpdate) == null ? void 0 : d.cart,
              customFragments: t,
              gqlClient: e,
              language: n,
              country: y
            });

          case 7:
            c = _context11.sent;
            return _context11.abrupt("return", f({
              cart: c,
              userErrors: (i = (E = a.data) == null ? void 0 : E.cartSelectedDeliveryOptionsUpdate) == null ? void 0 : i.userErrors,
              errors: a.errors,
              shopifyShopId: s,
              locale: C
            }));

          case 11:
            _context11.prev = 11;
            _context11.t0 = _context11["catch"](1);
            throw new Error(String(_context11.t0));

          case 14:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 11]]);
  }));
  return _ur.apply(this, arguments);
}

function yr(_ref17) {
  var r = _ref17.shopifyShopId,
      t = _ref17.shopifyStorefrontAccessToken,
      e = _ref17.shopifyCustomEndpoint,
      o = _ref17.fetchClient,
      s = _ref17.customFragments,
      _ref17$language = _ref17.language,
      n = _ref17$language === void 0 ? "EN" : _ref17$language,
      _ref17$country = _ref17.country,
      y = _ref17$country === void 0 ? "ZZ" : _ref17$country,
      _ref17$locale = _ref17.locale,
      C = _ref17$locale === void 0 ? "en-US" : _ref17$locale;

  var u = D(r),
      d = B({
    shopifyShopId: u,
    shopifyStorefrontAccessToken: t,
    shopifyCustomEndpoint: e,
    fetchClient: o
  }),
      E = X(s),
      i = {
    shopifyShopId: u,
    shopifyStorefrontAccessToken: t,
    shopifyCustomEndpoint: e,
    language: n,
    country: y,
    locale: C
  },
      a = function a() {
    return {
      shopifyShopId: i.shopifyShopId,
      language: i.language,
      country: i.country,
      locale: i.locale
    };
  };

  return {
    cart: function cart(c) {
      return j(_objectSpread(_objectSpread({
        customFragments: s,
        gqlClient: d
      }, a()), c));
    },
    cartAttributesUpdate: function cartAttributesUpdate(c) {
      return er(_objectSpread(_objectSpread({
        customFragments: E,
        gqlClient: d
      }, a()), c));
    },
    cartBuyerIdentityUpdate: function cartBuyerIdentityUpdate(c) {
      return ar(_objectSpread(_objectSpread({
        customFragments: E,
        gqlClient: d
      }, a()), c));
    },
    cartCreate: function cartCreate(c) {
      return nr(_objectSpread(_objectSpread({
        customFragments: E,
        gqlClient: d
      }, a()), {}, {
        params: c
      }));
    },
    cartDiscountCodesUpdate: function cartDiscountCodesUpdate(c) {
      return or(_objectSpread(_objectSpread({
        customFragments: E,
        gqlClient: d
      }, a()), c));
    },
    cartLinesAdd: function cartLinesAdd(c) {
      return ir(_objectSpread(_objectSpread({
        customFragments: E,
        gqlClient: d
      }, a()), c));
    },
    cartLinesUpdate: function cartLinesUpdate(c) {
      return sr(_objectSpread(_objectSpread({
        customFragments: s,
        gqlClient: d
      }, a()), c));
    },
    cartLinesRemove: function cartLinesRemove(c) {
      return cr(_objectSpread({
        customFragments: E,
        gqlClient: d,
        shopifyShopId: i.shopifyShopId,
        language: i.language,
        country: i.country,
        locale: i.locale
      }, c));
    },
    cartNoteUpdate: function cartNoteUpdate(c) {
      return dr(_objectSpread(_objectSpread({
        customFragments: s,
        gqlClient: d
      }, a()), c));
    },
    cartSelectedDeliveryOptionsUpdate: function cartSelectedDeliveryOptionsUpdate(c) {
      return ur(_objectSpread(_objectSpread({
        customFragments: s,
        gqlClient: d
      }, a()), c));
    },
    getConfig: function getConfig() {
      return _objectSpread({}, i);
    },
    setConfig: function setConfig(_ref18) {
      var c = _ref18.language,
          l = _ref18.country,
          h = _ref18.locale;
      i.language = c != null ? c : i.language, i.country = l != null ? l : i.country, i.locale = h != null ? h : i.locale;
    }
  };
}

export { yr as default };